export default __webpack_public_path__ + "static/media/appendix3.3b3c8b66.jpg";